import Quill from 'quill';
import Vue from 'vue';
import HelpCircleOutlineIcon from '@/common/components/svg-icons/HelpCircleOutlineIcon.vue';

export default {
    methods: {
        registerQuillBlot() {
            Quill.debug('error');
            const InlineEmbed = Quill.import('blots/embed');

            class ToolTipInlineEmbed extends InlineEmbed {
                static create(text) {
                    const node = super.create(text);
                    node.setAttribute('data-value', text);
                    node.innerHTML += '';
                    node.addEventListener('click', function() {
                        
                    }, false);

                    const infoText = document.createElement('span');
                    infoText.className = 'e3-tooltip-text';
                    infoText.innerHTML = text;
                    node.appendChild(infoText);
                    const Ctor = Vue.extend(HelpCircleOutlineIcon);
                    const vm = new Ctor({propsData: {size: 18}});
                    vm.$mount();
                    vm.$el.classList.add('text-primary', 'mr-1');
                    node.insertBefore(vm.$el, infoText);

                    return node;
                }

                static value(domNode) {
                    return domNode.getAttribute('data-value');
                }
   
                static formats() {
                    return ToolTipInlineEmbed.tagName;
                }
            }
            ToolTipInlineEmbed.blotName = 'tooltipblot';
            ToolTipInlineEmbed.tagName = 'span';
            ToolTipInlineEmbed.className = 'e3-tooltip';

            Quill.register(ToolTipInlineEmbed);
        },
        quillLinking(node, delta) {
            if(typeof(node.data) !== 'string') {return;}
            const regex = /https?:\/\/[^\s]+/g;
            const isLink = node.data.match(regex);

            if(isLink && isLink.length > 0) {
                const ops = [];
                let givenString = node.data;
                
                isLink.forEach(function(link) {
                    const split = givenString.split(link);
                    const beforeLink = split.shift();

                    ops.push({ insert: beforeLink });
                    ops.push({ insert: link, attributes: { link: link } });
                    givenString = split.join(link);
                });

                ops.push({ insert: givenString });
                delta.ops = ops;
            }

            return delta;
        }
    }
};
